if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer') ||
          document.querySelector('ajax-cart');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.warranty = this.closest('product-info').querySelector('[data-warranty-field]');
        this.hazardous = this.querySelector('[data-hazardous-shipping]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        let variantId = Number(formData.get('id'));
        if (this.cart && this.cart.getSectionsToRender) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        function handleWarranty() {
          if (!this.warranty || !this.warranty.checked) return;

          const items = [];
          const warrantyKey = 'warranty-' + Date.now();
          items.push({
            id: this.warranty.value,
            quantity: 1,
            properties: {
              '_warranty-key': warrantyKey,
              For: this.warranty.dataset.parentName
            }
          });
          items.push({
            id: Number(formData.get('id')),
            quantity: 1,
            properties: {
              '_warranty-key': warrantyKey,
              '_warranty-price': this.warranty.dataset.price
            }
          });

          return {items};
        }

        function handleHazardous() {
          if (!this.hazardous) return;

          const items = [];
          const hazardousKey = 'hazardous-' + Date.now();
          items.push({
            id: this.hazardous.value,
            quantity: 1,
            properties: {
              '_hazardous-key': hazardousKey,
              For: this.hazardous.dataset.parent
            }
          });
          items.push({
            id: Number(formData.get('id')),
            quantity: 1,
            properties: {
              '_hazardous-key': hazardousKey
            }
          });

          return {items};
        }

        function prepareFormData(items) {
          if (!items) return;

          config.headers['Content-Type'] = 'application/json';

          // Merge items with the same ID
          const mergedItems = items.map((item1) => {
            const foundItem = items.find((item2) => item1.id == item2.id && item1 !== item2);
            if (foundItem) {
              // Merge properties of item1 and foundItem
              item1.properties = {...item1.properties, ...foundItem.properties};
              return item1;
            }
            return item1;
          });

          // Remove duplicate parent object
          const uniqueItems = mergedItems.filter(
            (obj, index) => mergedItems.findIndex((item) => item.id === obj.id) === index
          );

          const formData = {
            items: uniqueItems,
            sections: this.cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          };
          config.body = JSON.stringify(formData);
        }

        // Main logic
        const warrantyData = handleWarranty.call(this);
        const hazardousData = handleHazardous.call(this);

        // Combine items if both conditions are met
        let combinedItems = [];
        if (warrantyData) combinedItems = combinedItems.concat(warrantyData.items);
        if (hazardousData) combinedItems = combinedItems.concat(hazardousData.items);

        // Prepare and send the form data
        if (combinedItems.length) prepareFormData.call(this, combinedItems);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (window.cartType === 'p80') {
                      this.cart.toggleCart();
                    } else {
                      this.cart.renderContents(response);
                    }
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              if (window.cartType === 'p80') {
                this.cart.toggleCart();
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty') && window.cartType !== 'p80')
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
